import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCallback, useMemo, useState } from "react";
import useQuery from "../../../helpers/useQuery";
import { ACTIVE_FORM_KEY, getDefaultActiveForm, getForm } from "./config";

const adminHardcodedData = {
  applicationId: 'AP000000123',
  applicationOwner: 'Datastake',
  applicationName: 'MMT',
}

const getData = ({ mod, user }) => {
  if (mod === 'admin') {
    return {
      ...user,
      ...adminHardcodedData,
      role: null,
    };
  }

  return {
    ...user,
    ...(user?.company?.settings || {}),
    role: user?.role?.description,
    companyLogo: user?.company?.logo,
    companyId: user?.company?.userId,
    companyCountry: user?.company?.country,
    companyName: user?.company?.name,
    companyEmail: user?.company?.admin?.email,
  };
}

export const noUpdate = [
  'companyLogo', 'role', 'companyId', 'companyCountry', 'companyName', 'systemNotifiications',
  'activityNotifiications', 'walletNotifiications', 'textOnlyEmail', 'companyEmail', 'company',
  'settings',
];

export const useForm = ({ mod }) => {
  const { user } = useSelector((state) => state.authentication);
  const options = useSelector((state) => state.authentication.options);
  // TO-DO add call or how they will be fetched
  const [data, setData] = useState(getData({ mod, user }));
  const countryOptions = useMemo(() => options?.countries || [], [options]);
  const query = useQuery();
  const activeFormKey = useMemo(() => getDefaultActiveForm(query), [query]);
  const push = useNavigate();

  const changeKey = useCallback((key) => {
    push(`${window.location.pathname}?${ACTIVE_FORM_KEY}=${key}`);
  }, [push]);

  const goToView = useCallback(() => {
    push(`/app/${mod}/view/settings?${ACTIVE_FORM_KEY}=${activeFormKey}`);
  }, [mod, activeFormKey, push]);

  const goToEdit = useCallback(() => {
    push(`/app/${mod}/edit/settings?${ACTIVE_FORM_KEY}=${activeFormKey}`);
  }, [mod, activeFormKey, push]);

  const form = useMemo(() => {
    return getForm({ user, countryOptions, mod });
  }, [user, countryOptions]);

  const activeForm = useMemo(() => form[activeFormKey], [form, activeFormKey]);

  return {
    data,
    setData,
    changeKey,
    form,
    activeForm,
    activeFormKey,
    initialData: user,
    goToView,
    goToEdit,
    user,
  };
};
